import { FC, JSX } from 'react';
import { useFormContext } from 'react-hook-form';

import Radio, { RadioGroup } from '@semcore/ui/radio';

import { Content, ContentPublication } from '@/entities/content/api/types';
import Input from '@/shared/ui/Input';

import s from './MetadataSettings.module.css';

export interface IPublicationSettingsProps {}

export const PublicationSettings: FC<
  IPublicationSettingsProps
> = (): JSX.Element => {
  const {
    watch,
    register,
    formState: { errors },
    setValue,
  } = useFormContext<Content>();
  const publication: ContentPublication = watch('publication');

  return (
    <div className="flex w-full flex-col gap-2">
      <div className="text-sm font-semibold text-black dark:text-white">
        Publication
      </div>

      <RadioGroup
        className="flex flex-col gap-3"
        value={publication}
        onChange={(val: ContentPublication) => setValue('publication', val)}
      >
        <Radio
          /*
          // @ts-ignore */
          value={ContentPublication.NotSpecified}
          label="For the whole site"
          size="l"
          className="text-base font-light leading-4"
        />
        <Radio
          /*
          // @ts-ignore */
          value={ContentPublication.SpecifiedPages}
          label="Only to the specified pages"
          size="l"
          className="text-base font-light leading-4"
        />
        {publication === ContentPublication.SpecifiedPages && (
          <Input
            className={s.finput}
            placeholder="Enter URL separated by commas"
            type="text"
            {...register('publication_urls')}
            error={
              errors?.publication_urls ? errors?.publication_urls.message : ''
            }
            errorClassName={
              errors?.publication_urls?.message?.length
                ? 'text-sm font-light'
                : 'hidden'
            }
          />
        )}
        <Radio
          /*
          // @ts-ignore */
          value={ContentPublication.ExcludingPages}
          label="Excluding the pages specified"
          size="l"
          className="text-base font-light leading-4"
        />
        {publication === ContentPublication.ExcludingPages && (
          <Input
            className={s.finput}
            placeholder="Enter URL separated by commas"
            type="text"
            {...register('publication_urls')}
            error={
              errors?.publication_urls ? errors?.publication_urls.message : ''
            }
            errorClassName={
              errors?.publication_urls?.message?.length
                ? 'text-sm font-light'
                : 'hidden'
            }
          />
        )}
      </RadioGroup>
    </div>
  );
};

export default PublicationSettings;
